import styled from "@emotion/styled";
import Box from "../../../primitives/Box/Box";
import { keyframes } from "@emotion/react";
import { getColor } from "../../../theme/theme";
import { colorPalette } from "../../../theme/colors";

export const WaveformWrap = styled.div`
  position: relative;
  flex: 1;
  height: 28px;
  display: flex;
  align-items: center;
  overflow: hidden;
  touch-action: none; /* important for drag seeking on mobile */
  overflow: visible;
`;

export const ProgressDot = styled(Box)`
  transform: translate(-50%, -50%);
  left: ${(p) => `${Math.max(0, Math.min(100, p.leftPct))}%`};
`;
export const AudioUploadRow = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const audioIndeterminate = keyframes`
  0%   { transform: translateX(-60%); }
  100% { transform: translateX(260%); }
`;

export const AudioUploadBar = styled.div`
  position: relative;
  flex: 1;
  height: 2px;
  border-radius: 999px;
  background: ${getColor("background.neutral.secondary")};
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;

    width: 30%;
    border-radius: inherit;
    background: ${colorPalette.popOrange[500]};

    animation: ${audioIndeterminate} 1.1s ease-in-out infinite alternate;
    will-change: transform;
  }
`;
